import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FormInput extends Component {
  static propTypes = {
    // Required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),

    //Optional
    errorMessage: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    selectOptions: PropTypes.array,
    children: PropTypes.node,
    placeholder: PropTypes.string,
    showError: PropTypes.bool,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
  }

  renderLabel(label, sublabel) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
          {
            sublabel &&
            <div className='sublabel'>
              {sublabel}
            </div>
          }
        </label>
      )
    : ''
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : '';
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault();
    this.props.handleInputRemoval();
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props;
    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const {
      errorMessage,
      label,
      sublabel,
      name,
      onChange,
      placeholder,
      type,
      value,
      showError,
      children,
      optionalClasses,
      disabled,
      onBlur,
      handleInputRemoval
    } = this.props;

    return (
      <div
        className={`input-container${optionalClasses ? ' ' + optionalClasses : ''}${showError && errorMessage ? ' error' : ''}`}
      >
        {this.renderLabel(label, sublabel)}
        <div className={`input-container-inner${handleInputRemoval ? ' removable' : ''}`}>
          <input
            name={name}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
          />
          {this.renderRemoveButton()}
        </div>
        {showError && this.renderErrorMessage(errorMessage)}
        {children}
      </div>
    )
  }
}


export default FormInput;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/FormInput.js